module.exports = __webpack_public_path__ + "static/media/muy-mala.8a992699.svg";